import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AccountRegistration from './AccountRegistration';
import AccountOverview from './AccountOverview';
import CardManagement from './CardManagement';
import Recharge from './Recharge';
import Withdraw from './Withdraw';
import AccountOpen from '../AccountOpen';

const AccountCenter: React.FC = () => {
  return (
    <Routes>
      {/* 账户中心 */}
      <Route path="/overview" element={<AccountOverview />} />
      <Route path="/cards" element={<CardManagement />} />
      <Route path="/recharge" element={<Recharge />} />
      <Route path="/withdraw" element={<Withdraw />} />
      
      {/* 开户流程 */}
      <Route path="/open" element={<AccountOpen />} />
      <Route path="/registration" element={<AccountRegistration />} />
      
      {/* 默认重定向到概览页面 */}
      <Route path="/" element={<Navigate to="/account/overview" replace />} />
      <Route path="/*" element={<Navigate to="/account/overview" replace />} />
    </Routes>
  );
};

export default AccountCenter;